import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `Dossier/${dossierId}/EntityChild`, method: 'GET', token: token })
}
